import React, { memo, useCallback } from 'react';
import { connect } from 'react-redux';
import { List } from '@mui/material';
import { createActions } from '../../../../store';
import { DEFAULT_LAYER_DROP_SHADOW_SETTINGS } from '../../../../CreatePageConstants';
import CollapsibleSwitchListItem from '../../../../../../list-items/CollapsibleSwitchListItem';
import CondensedListItem from '../../../../../../list-items/CondensedListItem';
import SliderListItem from '../../../../../../list-items/SliderListItem';
import ColorPickerListItem from '../../../../../../list-items/ColorPickerListItem/ColorPickerListItem';
import { previewHistoryBatch } from '../../../../store/extensions';

const WaveLayerShadowListItem = memo(({
    index,
    enabled,
    dropShadowSettings,
    updateWaveLayer,
    maxDropShadowBlur,
    maxDropShadowOpacity
}) => {
    const { color, blur, opacity } = dropShadowSettings;

    const onShadowEnabledChange = useCallback((value) => {
        updateWaveLayer(index, { dropShadowSettings: { enabled: value } });
    }, [updateWaveLayer, index]);

    const onShadowColorChange = useCallback((color) => {
        const value = color.hex.replace('#', '0x');
        updateWaveLayer(index, { dropShadowSettings: { color: value } });
    }, [updateWaveLayer, index]);

    const onShadowBlurChange = useCallback((value) => {
        previewHistoryBatch.start();
        updateWaveLayer(index, { dropShadowSettings: { blur: value } });
    }, [updateWaveLayer, index]);

    const onShadowOpacityChange = useCallback((value) => {
        previewHistoryBatch.start();
        updateWaveLayer(index, { dropShadowSettings: { opacity: value } });
    }, [updateWaveLayer, index]);

    return (
        <CollapsibleSwitchListItem
            checked={enabled}
            text='Shadow'
            onChange={onShadowEnabledChange}
            dense={true}
        >
            <List dense disablePadding>
                <ColorPickerListItem
                    text='Color'
                    color={color.replace('0x', '#')}
                    onChange={onShadowColorChange}
                    disableAlpha={true}
                />

                <CondensedListItem
                    elements={[
                        {
                            width: 6,
                            component: (
                                <SliderListItem
                                    title='Blur'
                                    value={blur}
                                    displayMultiplier={100 / maxDropShadowBlur}
                                    min={0}
                                    max={100}
                                    step={1}
                                    onValueChange={onShadowBlurChange}
                                />
                            )
                        },
                        {
                            width: 6,
                            component: (
                                <SliderListItem
                                    title='Opacity'
                                    value={opacity}
                                    displayMultiplier={100 / maxDropShadowOpacity}
                                    min={0}
                                    max={100}
                                    step={1}
                                    onValueChange={onShadowOpacityChange}
                                />
                            )
                        }
                    ]}
                />
            </List>
        </CollapsibleSwitchListItem>
    );
});

const mapStateToProps = (state, { index }) => {
    const layer = state.createPreview.present.videoSettings.visualizer.waveCircles[index];
    const globalSettings = state.createPreview.present.videoSettings.visualizer.dropShadowSettings;
    const layerShadowSettings = layer.customOptions?.dropShadowSettings || DEFAULT_LAYER_DROP_SHADOW_SETTINGS;

    return {
        enabled: layerShadowSettings.enabled,
        dropShadowSettings: layerShadowSettings.enabled ? layerShadowSettings : globalSettings,
        maxDropShadowBlur: state.create.maxValues.maxDropShadowBlur,
        maxDropShadowOpacity: state.create.maxValues.maxDropShadowOpacity
    };
};

const mapDispatchToProps = {
    updateWaveLayer: (index, properties) => createActions.updateWaveLayer(index, properties)
};

export default connect(mapStateToProps, mapDispatchToProps)(WaveLayerShadowListItem);
